(function ($) {
  let slideBarToggle = null;
  const elementsAnim = document.querySelectorAll(
    '#mobile-menu-wrapper > div, .navbar__inner'
  );

  function toggleClass(elements, className, add) {
    elements.forEach((element, index) => {
      setTimeout(() => {
        if (add) {
          element.classList.add(className);
        } else {
          element.classList.remove(className);
        }
      }, index * 50);
    });
  }

  function addSubMenuBackBtn() {
    const dropdownSubnavWrapper = $('.nav-mobile-wrapper > ul');

    dropdownSubnavWrapper.find('.dropdown').each(function () {
      const subnavWrapper = $(this).children(
        '.dropdown__subnav-wrapper.subnav-wrapper-depth-1'
      );
      if (subnavWrapper.length) {
        subnavWrapper
          .children('.dropdown__subnav')
          .prepend(
            '<li class="nav-item nav-item__back"><div class="nav-item__link-wrapper"><a class="nav-item__link" href="#"> <span class="icon icon-icon-left"></span> </a></div></li>'
          );
      }
    });

    $('.dropdown__subnav-wrapper.subnav-wrapper-depth-1 .nav-item__back').on(
      'click',
      function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).closest('.dropdown').removeClass('opened');
      }
    );
  }

  function toggleDropdown(event) {
    event.preventDefault();
    event.stopPropagation();

    const $toggle = $(this);
    const $li = $toggle.closest('.dropdown');

    $li.siblings('.dropdown').removeClass('opened');

    $li.toggleClass('opened');
  }

  function prepareDropdownForNav($nav) {
    $nav.find('.active').addClass('opened');
    $nav.find('.dropdown__toggle').on('click', toggleDropdown);
  }

  function closeSlidebarMenu() {
    slideBarToggle.attr('aria-expanded', false);
    $('body').removeClass('mobile-menu-open');
    $(document).off('click.close_slidebar').off('keyup.close_slidebar');
    toggleClass(elementsAnim, 'fadeInUp', false);
  }

  function tryClosingSlidebarMenu(event) {
    if (
      event.keyCode === 27 ||
      !$(event.target).closest('#mobile-menu-wrapper').length
    ) {
      $('.vtx-burger-container').focus();
      closeSlidebarMenu();
    }
  }

  function openSlidebarMenu() {
    slideBarToggle.attr('aria-expanded', true);
    $('body').addClass('mobile-menu-open');
    $(document)
      .on('click.close_slidebar', tryClosingSlidebarMenu)
      .on('keyup.close_slidebar', tryClosingSlidebarMenu);
    toggleClass(elementsAnim, 'fadeInUp', true);
  }

  function initMenuMobile() {
    slideBarToggle = $('.vtx-burger-container');
    const $mobileMenu = $('#mobile-menu');

    slideBarToggle.on('click', function (event) {
      event.stopPropagation();
      if ($('body').hasClass('mobile-menu-open')) {
        closeSlidebarMenu();
      } else {
        openSlidebarMenu();
      }
    });

    prepareDropdownForNav($mobileMenu.find('.nav-mobile'));
  }

  // Add tabindex to nav items heading with dropdown
  function updateTabIndex() {
    const navItems = document.querySelectorAll(
      '.nav-primary li.nav-item--heading'
    );
    navItems.forEach((navItem) => {
      if (navItem.classList.contains('dropdown')) {
        const navLink = navItem.querySelector('.nav-item__link');
        if (navLink) {
          navLink.setAttribute('tabindex', '0');
        }
      }
    });
  }

  // change input search id
  function changeInputSearchId() {
    const inputSearch = document.querySelector(
      '.findstr-search-autocomplete-input'
    );
    if (inputSearch) {
      inputSearch.setAttribute('id', 'findstr_main_search_input_mobile');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMenuMobile();
    addSubMenuBackBtn();
    updateTabIndex();
    changeInputSearchId();
  });
})(jQuery);
